import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  ANALYSIS_TOOL_SPACING,
  SHARED_MAIN_VIEW_COMPONENT_WITH_MARGIN_STYLES,
} from 'analysis-tool/AnalysisToolConstants';
import getOutputFilesFromStep from 'analysis-tool/data/getOutputFilesFromStep';
import {assert} from 'Asserts';
import ScratchFilePaneContent from 'pipelines/files/ScratchFilePaneContent';
import getTestProps from 'test/lib/cypress/getTestProps';
import Pane from 'ui-library/pane/Pane';

import {AnalysisMainViewItemType, MainViewComponentProps} from '../MainViewTypes';

export default function FileView({
  selectedItem: {fileId},
  step,
}: MainViewComponentProps<AnalysisMainViewItemType.FILE>): JSX.Element {
  const scratchFile = getOutputFilesFromStep(step).find((file) => file.id === fileId);
  assert(scratchFile != null, 'Expected specified fileId to be present in step output datas', {
    fileId,
    step,
  });
  assert(scratchFile.externalFileId != null, 'Pipeline file has not been finalized', {fileId});

  return (
    <div className={css(styles.wrapper)} {...getTestProps({component: 'FileView', element: 'root'})}>
      <Pane title={scratchFile.filename}>
        <div className={css(styles.filePaneContent)}>
          <ScratchFilePaneContent scratchFile={scratchFile} />
        </div>
      </Pane>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    ...SHARED_MAIN_VIEW_COMPONENT_WITH_MARGIN_STYLES,
    height: '100%',
  },
  filePaneContent: {
    padding: ANALYSIS_TOOL_SPACING,
    height: '100%',
  },
});
